(() => {
  const normalize = s =>
    (s || '')
      .toString()
      .normalize?.('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const roots = [...document.querySelectorAll('[data-mega-menu]')];
  if (!roots.length) return;

  // Desktop top menu container (Dawn / desktop)
  const header = document.querySelector('.section-header');
  const headerNav = document.querySelector('.header__inline-menu .list-menu')
                 || document.querySelector('.header__inline-menu')
                 || document.querySelector('.header .list-menu');
  if (!header || !headerNav) return;

  // Map: label -> root
  const megaByLabel = new Map(
    roots.map(r => [normalize(r.getAttribute('data-trigger')), r])
  );

  // Helpers
  const panelOf = r => r?.querySelector('.MegaMenu__panel');
  const closeAll = () => {
    roots.forEach(r => {
      const p = panelOf(r);
      if (p && !p.hidden) { p.hidden = true; p.setAttribute('aria-hidden', 'true'); }
    });
  };
  const openRoot = r => {
    if (!r) return;
    closeAll();
    const p = panelOf(r);
    if (p) { p.hidden = false; p.setAttribute('aria-hidden', 'false'); }
  };

  // 1) Hovering a top-level item opens its mega if it exists, otherwise closes all.
  const topItems = [...headerNav.querySelectorAll(':scope > li > a, :scope > li > button')];
  topItems.forEach(a => {
    a.addEventListener('mouseenter', () => {
      const label = normalize(a.textContent);
      const root = megaByLabel.get(label);
      if (root) openRoot(root);
      else closeAll();
    });
    a.addEventListener('focus', () => {
      const label = normalize(a.textContent);
      const root = megaByLabel.get(label);
      if (root) openRoot(root);
      else closeAll();
    });
  });

  // 2) Keep panel open while mouse is over the panel itself
  roots.forEach(r => {
    const p = panelOf(r);
    if (!p) return;
    p.addEventListener('mouseenter', () => openRoot(r));
    p.addEventListener('mouseleave', () => closeAll());
  });

  // 3) Close when leaving the header area or clicking elsewhere
  header.addEventListener('mouseleave', () => closeAll());
  document.addEventListener('scroll', closeAll, { passive: true });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-mega-menu]') && !e.target.closest('.header__inline-menu')) closeAll();
  });

  
})();


// --- Align mega to the beginning of the main menu (desktop) ---
(() => {
  const headerNav =
    document.querySelector('.header__inline-menu .list-menu') ||
    document.querySelector('.header__inline-menu');

  if (!headerNav) return;

  const syncMegaOffset = () => {
    const rect = headerNav.getBoundingClientRect();
    // rect.left is relative to viewport; our panel is fixed to the viewport => perfect
    document.documentElement.style.setProperty('--mega-nav-left', `${Math.max(0, rect.left)}px`);
  };

  // run now and on changes that could move things
  syncMegaOffset();
  window.addEventListener('resize', syncMegaOffset);
  window.addEventListener('scroll', syncMegaOffset, { passive: true });
})();
